import { LanguageSwitcherList } from "@modules/Navbar/components/LanguageSwitcherList";
import { useTranslation } from "react-i18next";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@ui/components/ui/sheet";

type Props = {
  showDropdown: boolean;
  setShowDropdown: (showDropdown: boolean) => void;
};

export const LanguageSwitcherModal: React.FC<Props> = ({
  showDropdown,
  setShowDropdown,
}) => {
  const { t } = useTranslation("Navbar");
  return (
    <Sheet open={showDropdown} onOpenChange={setShowDropdown}>
      <SheetContent side="bottom" className="rounded-t-xl">
        <SheetHeader>
          <SheetTitle>{t("selectYourCountry")}</SheetTitle>
        </SheetHeader>
        <div className="overflow-y-auto px-4 pb-6">
          <LanguageSwitcherList isMobileView />
        </div>
      </SheetContent>
    </Sheet>
  );
};
